// extracted by mini-css-extract-plugin
export var infoItem = "_tc-2";
export var title = "_tc-0";
export var value = "_tc-1";